import type { VerseDef } from "../game/cards/types";

export const VERSES: VerseDef[] = [
  {
    id: "heb-11-1",
    reference: "Hebrews 11:1",
    textKjv:
      "Now faith is the substance of things hoped for, the evidence of things not seen.",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Reliable broad Answer. Hunts Fear, then Despair, then Doubt. Answer I alone off-type; Meets on match. Vs Doubt: converts outer shells (does not classic step). Light Truth nudge.",
    respectMask: "autoOnly",
    selector: "typePriority",
    priorityTypes: ["fear", "despair", "doubt"],
    /** Broad: reliable vs common lie types (not a III-delete). */
    strongVs: ["fear", "despair", "doubt"],
    snipeTier: "broad",
    answerLevels: 1,
    tiltSlam: -6,
  },
  {
    id: "rom-10-17",
    reference: "Romans 10:17",
    textKjv: "So then faith cometh by hearing, and hearing by the word of God.",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Drag onto a lie: Soften I only (no Meets bonus). Opens a full III so Redeem can fire. Vs Doubt: one outer shell toward Faith (Faith category still meets).",
    respectMask: "exactSlot",
    selector: "strongestLie",
    snipeTier: "soften",
    answerLevels: 1,
  },
  {
    id: "mark-11-22",
    reference: "Mark 11:22",
    textKjv: "And Jesus answering saith unto them, Have faith in God.",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Short snipe at the deepest threatened layer. Answer I + Meets I vs Fear/Doubt; perfect deep aim adds Aim I. Vs Doubt: can peel multiple outers or settle an open core.",
    respectMask: "autoOnly",
    selector: "innermostLie",
    strongVs: ["fear", "doubt"],
    snipeTier: "micro",
    answerLevels: 1,
  },
  {
    id: "ps-56-3",
    reference: "Psalm 56:3",
    textKjv: "What time I am afraid, I will trust in thee.",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Short snipe at the strongest lie. Answer I + Meets I vs Fear/Doubt; perfect aim can add Aim I. Then Still the lie briefly if it remains (pauses Doubt re-doubt).",
    respectMask: "autoOnly",
    selector: "strongestLie",
    strongVs: ["fear", "doubt"],
    snipeTier: "micro",
    answerLevels: 1,
    slowDuration: 4,
    slowFactor: 0.35,
  },
  {
    id: "rom-15-13",
    reference: "Romans 15:13",
    textKjv:
      "Now the God of hope fill you with all joy and peace in believing, that ye may abound in hope, through the power of the Holy Ghost.",
    category: "peace",
    kind: "instant",
    effectSummary:
      "Steady Answer that hunts Despair first, then Fear. Answer I + Meets I on match; not a full III wipe. Light Truth nudge.",
    respectMask: "layerPrefer",
    selector: "typePriority",
    priorityTypes: ["despair", "fear"],
    strongVs: ["despair", "fear"],
    snipeTier: "standard",
    answerLevels: 1,
    tiltSlam: -6,
  },
  {
    id: "john-14-27",
    reference: "John 14:27",
    textKjv:
      "Peace I leave with you, my peace I give unto you: not as the world giveth, give I unto you. Let not your heart be troubled, neither let it be afraid.",
    category: "peace",
    kind: "instant",
    effectSummary:
      "Drag a crowded layer (prefers Heart): Chip I on every lie, strong Truth push, then Still the row briefly.",
    respectMask: "layerOnly",
    selector: "layerChip",
    preferLayer: "heart",
    tiltSlam: -18,
    answerLevels: 1,
    slowDuration: 4,
    slowFactor: 0.4,
  },
  {
    id: "2cor-10-5",
    reference: "2 Corinthians 10:5",
    textKjv:
      "Casting down imaginations, and every high thing that exalteth itself against the knowledge of God, and bringing into captivity every thought to the obedience of Christ.",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Mind only: Chip I on every lie there. Strong when thoughts swarm; weak if Mind is empty. Vs Doubt: peels one outer shell (never the core).",
    respectMask: "layerOnly",
    selector: "layerChip",
    lockLayer: "mind",
    preferLayer: "mind",
    tiltSlam: -12,
    answerLevels: 1,
  },
  {
    id: "col-3-15",
    reference: "Colossians 3:15",
    textKjv:
      "And let the peace of God rule in your hearts, to the which also ye are called in one body; and be ye thankful.",
    category: "peace",
    kind: "instant",
    effectSummary:
      "Heart only: Chip I on every lie, light Truth push, then mild Still on the row.",
    respectMask: "layerOnly",
    selector: "layerChip",
    lockLayer: "heart",
    preferLayer: "heart",
    tiltSlam: -10,
    answerLevels: 1,
    slowDuration: 3.5,
    slowFactor: 0.45,
  },
  {
    id: "eph-6-16",
    reference: "Ephesians 6:16",
    textKjv:
      "Above all, taking the shield of faith, wherewith ye shall be able to quench all the fiery darts of the wicked.",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Drag a layer: Chip I on Fear only. Great vs Whisper piles; weak vs pure Despair.",
    respectMask: "layerOnly",
    selector: "layerChip",
    preferLayer: "mind",
    chipOnlyTypes: ["fear"],
    strongVs: ["fear"],
    tiltSlam: -6,
    answerLevels: 1,
  },
  {
    id: "phil-4-6-7",
    reference: "Philippians 4:6-7",
    textKjv:
      "Be careful for nothing; but in every thing by prayer and supplication with thanksgiving let your requests be made known unto God. And the peace of God, which passeth all understanding, shall keep your hearts and minds through Christ Jesus.",
    category: "peace",
    kind: "placeable",
    effectSummary:
      "Abide a Guard III Prayer on Heart (or nearby). Truth pressure + contest. You may replace your own Prayer.",
    respectMask: "layerPrefer",
    preferLayer: "heart",
    placeable: {
      name: "Guard Prayer",
      level: 3,
      // Long dual-verse proclaim — pressure earns the mouth lock
      verbs: { pressure: -9, guard: true, contest: 2.5 },
    },
  },
  {
    id: "isa-26-3",
    reference: "Isaiah 26:3",
    textKjv:
      "Thou wilt keep him in perfect peace, whose mind is stayed on thee: because he trusteth in thee.",
    category: "peace",
    kind: "placeable",
    effectSummary:
      "Abide on Mind: strong Truth pressure and contest against lies sharing the row.",
    respectMask: "exactSlot",
    preferLayer: "mind",
    placeable: {
      name: "Stayed Mind",
      level: 2,
      verbs: { pressure: -9.5, contest: 4.5 },
    },
  },
  {
    id: "prov-3-6",
    reference: "Proverbs 3:6",
    textKjv:
      "In all thy ways acknowledge him, and he shall direct thy paths.",
    category: "faith",
    kind: "placeable",
    effectSummary:
      "Path Prayer: steps outward (Will→Heart→Mind) when clear. Contests the *next* layer ahead, not its own. No Guard — expand, don’t hold the line.",
    respectMask: "adjacentExpand",
    preferLayer: "heart",
    placeable: {
      name: "Directed Path",
      level: 2,
      // Path, not wall: no Guard; light contest on the layer ahead (not here)
      verbs: {
        pressure: -5.5,
        contest: 0.95,
        contestNextLayer: true,
        advanceAfter: 5.2,
      },
    },
  },
  {
    id: "thess-5-17",
    reference: "1 Thessalonians 5:17",
    textKjv: "Pray without ceasing.",
    category: "peace",
    kind: "instant",
    effectSummary:
      "Drag a damaged Prayer: Restore Keep to full (clear wear). Short speak. Stays in hand if none need help.",
    respectMask: "exactSlot",
    selector: "restorePrayer",
  },
  {
    id: "eccl-4-9-10",
    reference: "Ecclesiastes 4:9-10",
    textKjv:
      "Two are better than one; because they have a good reward for their labour. For if they fall, the one will lift up his fellow: but woe to him that is alone when he falleth; for he hath not another to help him up.",
    category: "peace",
    kind: "instant",
    effectSummary:
      "Gather: drag a Prayer below full strength. Other residual (I) Prayers feed it (+1 level each), up to this keep’s max (II-cap takes 1; III-cap takes up to 2). Never raises max. Stays in hand if no host or no other I’s.",
    respectMask: "exactSlot",
    selector: "gatherPrayers",
  },
  {
    id: "neh-8-10",
    reference: "Nehemiah 8:10",
    textKjv: "...for the joy of the Lord is your strength.",
    category: "peace",
    kind: "instant",
    effectSummary:
      "8s Joy: slowly wears every Fear on the board (~I each if they stay under it), mild Still, +4 Integrity. Soft multi-target — not a wipe.",
    respectMask: "autoOnly",
    selector: "self",
    restoreIntegrity: 4,
    joyField: {
      duration: 8,
      // 8 × 0.125 ≈ 1.0 wear → one step if uninterrupted
      wearPerSec: 0.125,
      onlyTypes: ["fear"],
      // Gentler than dedicated Still (0.3–0.35)
      slowFactor: 0.62,
      maxStepsPerLie: 1,
    },
  },
  {
    id: "ps-46-10",
    reference: "Psalm 46:10",
    textKjv: "Be still, and know that I am God...",
    category: "peace",
    kind: "instant",
    effectSummary:
      "Drag a layer: Still all lies there for 5s (advance/spread crawl) plus a light Truth push.",
    respectMask: "layerOnly",
    selector: "slowLayer",
    preferLayer: "mind",
    slowDuration: 5,
    slowFactor: 0.35,
    tiltSlam: -8,
  },
  {
    id: "mark-4-39",
    reference: "Mark 4:39",
    textKjv:
      "And he arose, and rebuked the wind, and said unto the sea, Peace, be still. And the wind ceased, and there was a great calm.",
    category: "peace",
    kind: "instant",
    effectSummary:
      "Drag one lie: Still 6s, then Answer I + Meets I vs Fear. Control first — not a full III wipe alone.",
    respectMask: "exactSlot",
    selector: "slowLie",
    strongVs: ["fear"],
    snipeTier: "standard",
    slowDuration: 6,
    slowFactor: 0.3,
    answerLevels: 1,
  },
  {
    id: "gen-50-20",
    reference: "Genesis 50:20",
    textKjv:
      "But as for you, ye thought evil against me; but God meant it unto good, to bring to pass, as it is this day, to save much people alive.",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Strong Redeem: only on an already-weakened lie (chip a III first). Becomes a Prayer one step stronger when possible.",
    respectMask: "exactSlot",
    selector: "convertLie",
    strongVs: ["despair"],
    convertPrayerName: "Meant for Good",
    /** +1 above the lie (III → fortified III) */
    convertPrayerBonus: 1,
  },
  {
    id: "rom-8-28",
    reference: "Romans 8:28",
    textKjv:
      "And we know that all things work together for good to them that love God...",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Weak Redeem: chip a lie first, then turn it into a Prayer at the same strength. Prefers Despair.",
    respectMask: "layerPrefer",
    selector: "convertLie",
    priorityTypes: ["despair", "fear"],
    strongVs: ["despair"],
    convertPrayerName: "For Good",
    /** Same level as the lie */
    convertPrayerBonus: 0,
  },
  {
    id: "mark-11-23-24",
    reference: "Mark 11:23-24",
    textKjv:
      "For verily I say unto you, That whosoever shall say unto this mountain, Be thou removed, and be thou cast into the sea; and shall not doubt in his heart, but shall believe that those things which he saith shall come to pass; he shall have whatsoever he saith. Therefore I say unto you, What things soever ye desire, when ye pray, believe that ye receive them, and ye shall have them.",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Empower: next Answer or Chip gains +I. Eligible cards glow gold — set up, then strike.",
    respectMask: "autoOnly",
    selector: "empower",
    empowerCharges: 1,
    empowerBonusSteps: 1,
  },
  {
    id: "eph-6-17",
    reference: "Ephesians 6:17",
    textKjv:
      "And take the helmet of salvation, and the sword of the Spirit, which is the word of God:",
    category: "faith",
    kind: "instant",
    effectSummary:
      "Generalist sword: Answer I on the strongest lie; + Meets I vs Fear or Despair. Not a full III wipe — Empower can push further.",
    respectMask: "autoOnly",
    selector: "strongestLie",
    strongVs: ["fear", "despair"],
    snipeTier: "broad",
    answerLevels: 1,
  },
  {
    id: "isa-40-31",
    reference: "Isaiah 40:31",
    textKjv:
      "But they that wait upon the Lord shall renew their strength; they shall mount up with wings as eagles; they shall run, and not be weary; and they shall walk, and not faint.",
    category: "peace",
    kind: "instant",
    effectSummary:
      "Drag a damaged Prayer: Restore Keep, Renew 7s (half wear), and clear wear on neighbors on that layer. Longer speak than 1 Thess 5:17.",
    respectMask: "exactSlot",
    selector: "restorePrayer",
    fortifyAfterRestore: { duration: 7, wearFactor: 0.5 },
    mendAdjacent: { clearWear: true, levels: 0 },
  },
  {
    id: "ps-91-1-2",
    reference: "Psalm 91:1-2",
    textKjv:
      "He that dwelleth in the secret place of the most High shall abide under the shadow of the Almighty. I will say of the Lord, He is my refuge and my fortress: my God; in him will I trust.",
    category: "peace",
    kind: "placeable",
    effectSummary:
      "Abide Refuge on Will: Guard + Truth pressure. While it holds Will, Integrity slowly regenerates.",
    respectMask: "layerPrefer",
    preferLayer: "will",
    placeable: {
      name: "Secret Place Refuge",
      level: 2,
      verbs: {
        pressure: -7.5,
        guard: true,
        contest: 2.2,
        refugeRegen: 2.4,
      },
    },
  },
  {
    id: "jas-1-5",
    reference: "James 1:5",
    textKjv:
      "If any of you lack wisdom, let him ask of God, that giveth to all men liberally, and upbraideth not; and it shall be given him.",
    category: "wisdom",
    kind: "instant",
    effectSummary:
      "Short Wisdom snipe. Meets Doubt. On Dogma: Name the demand (type chip) and Still it; peels only if the core/shell wants Wisdom.",
    respectMask: "autoOnly",
    selector: "typePriority",
    priorityTypes: ["dogma", "doubt"],
    strongVs: ["doubt"],
    snipeTier: "standard",
    answerLevels: 1,
    nameLie: true,
    slowDuration: 3,
    slowFactor: 0.4,
  },
  {
    id: "jas-3-16-17",
    reference: "James 3:16-17",
    textKjv:
      "For where envying and strife is, there is confusion and every evil work. But the wisdom that is from above is first pure, then peaceable, gentle, and easy to be intreated, full of mercy and good fruits, without partiality, and without hypocrisy.",
    category: "wisdom",
    kind: "instant",
    effectSummary:
      "Wipe every Confusion on the board. If a Dogma core is open, Cast it down on the same speak. Brief Still on leftover residuals.",
    respectMask: "autoOnly",
    selector: "self",
    wipeConfusion: true,
    castDown: true,
  },
  {
    id: "1cor-14-33",
    reference: "1 Corinthians 14:33",
    textKjv:
      "For God is not the author of confusion, but of peace, as in all churches of the saints.",
    category: "wisdom",
    kind: "instant",
    effectSummary:
      "Shorter wipe: silence every Confusion. Wisdom from above, not a Fear/Despair snipe.",
    respectMask: "autoOnly",
    selector: "self",
    wipeConfusion: true,
  },
  {
    id: "col-2-8",
    reference: "Colossians 2:8",
    textKjv:
      "Beware lest any man spoil you through philosophy and vain deceit, after the tradition of men, after the rudiments of the world, and not after Christ.",
    category: "wisdom",
    kind: "instant",
    effectSummary:
      "Lay aside a hand card you will not need (drop onto it, or auto-picks a brick) and draw. If a Dogma core is open, Cast it down.",
    respectMask: "autoOnly",
    selector: "self",
    layAside: true,
    castDown: true,
  },
];

/**
 * Proclaim lines + speech budgets (P3).
 *
 * First-pass policy (VO-aligned baseline):
 * - Prefer natural recitation; set speakSeconds from measured VO (± pad).
 * - Longer lock = harder (mouth busy) — game was slightly easy.
 * - Shorten text only when the effect is too weak to earn a long line.
 * - Bands: micro ~1.4–1.8 · standard ~2.5–4.5 · heavy ~5–6.5 · redeem/abide as earned
 *
 * Durations from xAI TTS (zagan answers / ara prayers); re-measure after text edits.
 */
const SPEAK: Record<string, { proclaimText: string; speakSeconds: number }> = {
  "heb-11-1": {
    // Full definition — broad coverage Answer (long lock, not deeper steps)
    proclaimText:
      "Now faith is the substance of things hoped for, the evidence of things not seen.",
    speakSeconds: 5.6,
  },
  "rom-10-17": {
    // Soften tool — measured VO (~3.9s); hearing the Word opens the claim
    proclaimText:
      "So then faith cometh by hearing, and hearing by the word of God.",
    speakSeconds: 3.9,
  },
  "mark-11-22": {
    proclaimText: "Have faith in God.",
    speakSeconds: 1.5,
  },
  "ps-56-3": {
    // Time is the real cost (was “cheap” sniper at 1.7s)
    proclaimText: "What time I am afraid, I will trust in thee.",
    speakSeconds: 2.9,
  },
  "rom-15-13": {
    proclaimText:
      "Now the God of hope fill you with all joy and peace in believing.",
    speakSeconds: 3.9,
  },
  "john-14-27": {
    // Layer chip + hard tilt earns a longer peace line
    proclaimText:
      "Peace I leave with you. Let not your heart be troubled, neither let it be afraid.",
    speakSeconds: 4.9,
  },
  "2cor-10-5": {
    proclaimText:
      "Bringing into captivity every thought to the obedience of Christ.",
    speakSeconds: 4.3,
  },
  "col-3-15": {
    proclaimText: "And let the peace of God rule in your hearts.",
    speakSeconds: 2.8,
  },
  "eph-6-16": {
    // Mild shorten vs old 6s line; fear-only chip
    proclaimText:
      "Taking the shield of faith, to quench all the fiery darts of the wicked.",
    speakSeconds: 4.5,
  },
  "phil-4-6-7": {
    // Dual-verse prayer — long lock; placeable pressure buffed to match
    proclaimText:
      "By prayer and supplication with thanksgiving, the peace of God shall keep your hearts and minds.",
    speakSeconds: 5.8,
  },
  "isa-26-3": {
    proclaimText:
      "Thou wilt keep him in perfect peace, whose mind is stayed on thee.",
    speakSeconds: 4.1,
  },
  "prov-3-6": {
    proclaimText:
      "In all thy ways acknowledge him, and he shall direct thy paths.",
    speakSeconds: 3.4,
  },
  "thess-5-17": {
    proclaimText: "Pray without ceasing.",
    speakSeconds: 1.6,
  },
  "eccl-4-9-10": {
    proclaimText:
      "Two are better than one; for if they fall, the one will lift up his fellow.",
    speakSeconds: 3.8,
  },
  "neh-8-10": {
    proclaimText: "For the joy of the Lord is your strength.",
    // Signature payoff — not a free instant
    speakSeconds: 3.4,
  },
  "ps-46-10": {
    proclaimText: "Be still, and know that I am God.",
    speakSeconds: 2.7,
  },
  "mark-4-39": {
    proclaimText: "Peace, be still.",
    speakSeconds: 1.6,
  },
  "gen-50-20": {
    proclaimText: "Ye thought evil against me; but God meant it unto good.",
    speakSeconds: 3.6,
  },
  "rom-8-28": {
    proclaimText:
      "And we know that all things work together for good to them that love God.",
    speakSeconds: 5.2,
  },
  "mark-11-23-24": {
    // Setup card — measured xAI TTS (~8s); long lock so Empower isn't free tempo
    proclaimText:
      "Whosoever shall say unto this mountain, Be thou removed, and shall not doubt in his heart, he shall have whatsoever he saith.",
    speakSeconds: 8.1,
  },
  "eph-6-17": {
    // Sword — broad Answer (both lie types); firm line, not base-2 depth
    proclaimText:
      "Take the sword of the Spirit, which is the word of God.",
    speakSeconds: 3.2,
  },
  "isa-40-31": {
    proclaimText:
      "They that wait upon the Lord shall renew their strength.",
    speakSeconds: 3.5,
  },
  "ps-91-1-2": {
    // Long Abide — refuge on Will is worth the mouth (measured VO)
    proclaimText:
      "He that dwelleth in the secret place of the most High shall abide under the shadow of the Almighty.",
    speakSeconds: 5.6,
  },
  "jas-1-5": {
    proclaimText:
      "If any of you lack wisdom, let him ask of God, and it shall be given him.",
    speakSeconds: 5.4,
  },
  "jas-3-16-17": {
    proclaimText:
      "Where envying and strife is, there is confusion. But the wisdom that is from above is first pure, then peaceable.",
    speakSeconds: 8.6,
  },
  "1cor-14-33": {
    proclaimText: "For God is not the author of confusion, but of peace.",
    speakSeconds: 3.7,
  },
  "col-2-8": {
    proclaimText:
      "Beware lest any man spoil you through philosophy and vain deceit, after the tradition of men.",
    speakSeconds: 6.3,
  },
};

for (const v of VERSES) {
  const s = SPEAK[v.id];
  if (s) {
    v.proclaimText = s.proclaimText;
    v.speakSeconds = s.speakSeconds;
  } else {
    v.proclaimText = v.textKjv.replace(/\s+/g, " ").trim();
    v.speakSeconds = Math.min(
      6,
      Math.max(1.5, v.proclaimText.split(/\s+/).length * 0.28),
    );
  }
}

export const STARTER_DECK_IDS = VERSES.map((v) => v.id);

/** Wisdom verses — gift / deck-check for Dogma. */
export const WISDOM_VERSE_IDS: readonly string[] = [
  "jas-1-5",
  "jas-3-16-17",
  "1cor-14-33",
  "col-2-8",
];

export const WISDOM_GIFT_ID = "jas-1-5";

export function isWisdomVerseId(id: string): boolean {
  return WISDOM_VERSE_IDS.includes(id);
}

const byId = new Map(VERSES.map((v) => [v.id, v]));

export function verseById(id: string): VerseDef | undefined {
  return byId.get(id);
}

export function proclaimLine(def: VerseDef): string {
  return (def.proclaimText ?? def.textKjv).replace(/\s+/g, " ").trim();
}

export function speakDuration(def: VerseDef): number {
  return def.speakSeconds ?? 2.5;
}
